import React from "react";
import LargeHubLinkSection from "./LargeHubLinkSection";

const MoreOutOfModeCards = () => {
  const sectionTitle = "Get more out of Mode";
  const cardList = [
    {
      title: "The Mode Data blog",
      subTitle:
        "Insights about data, for everyone",
      buttonHref: "https://mode.com/blog/",
    },
    {
      title: "Visual Explorer Guides",
      subTitle:
        "Examples of possible visualizations you can build using Visual Explorer",
      buttonHref: "https://mode.com/visual-explorer-guides/",
    },
    {
      title: "Example Gallery",
      subTitle: "Explore example analysis and visualizations",
      buttonHref: "https://mode.com/example-gallery/",
    },
    {
      title: "Report Themes",
      subTitle:
        "Customize your reports with our matching themes and color palettes",
      buttonHref: "https://mode.com/report-themes/",
    },
    {
      title: "Maturity Model",
      subTitle:
        "See where your organization sits on the path to best data practices",
      buttonHref: "https://mode.com/maturity-model-assessment/",
    },
  ];
  return (
    <LargeHubLinkSection sectionTitle={sectionTitle} cardList={cardList} />
  );
};

export default MoreOutOfModeCards;
